import { ref } from 'vue';
import type { Url } from '@global-types/url';
import Logger from '../logger/logger';

const cache = new Map<string, Promise<string>>();

export const useIconCache = (name: string) => {
  const svgUrl = ref<Url>();

  const setSvgUrl = async (): Promise<void> => {
    try {
      if (!cache.has(name)) {
        cache.set(
          name,
          import(`@icons/${name}.svg`).then((module) => module.default),
        );
      }

      svgUrl.value = await cache.get(name);
    } catch (error) {
      Logger.error(`The icon ${name} does not exist`);
    }
  };

  /* eslint-disable no-void */
  void setSvgUrl();

  return {
    svgUrl,
    cache,
  };
};
